import { FormControl, InputLabel, InputAdornment, Typography } from "@mui/material"
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import ProductOption from "./ProductOption";
import Helper from "./Helper";
import { capitalizeText } from "../utils/strings";
import EasySnackBar from "./EasySnackBar";
import { useState } from "react";
import { OPTIONS_VARIANTS } from "../utils/structures";
import { USER_PLANS } from "../utils/structures";

export default function AddProductOptions(props) {

    const [newOptionName, setNewOptionName] = useState("")
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')

    const addOption = () => {

        if (props.userMenu.plan.type === USER_PLANS.free
            && props.productOptions.length >= 2) {
            setErrorMessage('Alcanzaste el limite de extras por producto de la version gratuita, consigue el plan PRO')

        } else if (newOptionName === '') {
            setErrorMessage('La opción debe tener un nombre')

        } else {
            let exists = false
            for (let i = 0; i < props.productOptions.length; i++) {
                if (props.productOptions[i].name === capitalizeText(newOptionName)) {
                    exists = true
                    break
                }
            }

            if (!exists) {
                props.setProductOptions(prev => prev.concat(
                    {
                        name: capitalizeText(newOptionName),
                        subOptions: [],
                        type: OPTIONS_VARIANTS.selectOption,
                        elegibleOptions: -1,
                    }
                ))
                setSuccessMessage('Opción creada correctamente')

            } else {
                setErrorMessage('Ya existe una versión con ese nombre')
            }
        }
    }

    return (
        <>
            <Typography variant="h4">
                Versiones o extras
            </Typography>

            <Typography>
                Puedes permitirle a tus clientes personalizar su pedido, para eso puedes crear una o varias versiones de tu producto cada una con sus opciones de personalización.
                Cada producto puede tener varias versiones
                <br />
                <br />
                Ejemplos: (Hamburguesa con papas fritas)
                <br />
                <b>Versión:</b> Tipo de carne | <b>Opciones:</b> Vacio, Bondiola, Pollo
                <br />
                <b>Versión:</b> Extra en las papas | <b>Opciones:</b> Cheddar, Cheddar y Panceta, Papas Bomba
                <br />
            </Typography>

            <List sx={{ width: '100%' }}>
                {!props.productOptions ? null :
                    props.productOptions.map((option, index) => {
                        return (
                            <ProductOption
                                productOptions={props.productOptions}
                                setProductOptions={props.setProductOptions}
                                optionIndex={index}
                                key={option.name}
                            />
                        )
                    })
                }
            </List>

            <Stack direction='row'>
                <FormControl variant="outlined" sx={{ width: '100%' }}>
                    <InputLabel htmlFor="outlined-adornment-password">Nueva version</InputLabel>
                    <OutlinedInput
                        onChange={e => { setNewOptionName(e.target.value) }}
                        value={newOptionName}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                addOption();
                            }
                        }}
                        endAdornment={
                            <InputAdornment position="end">

                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                <IconButton onClick={addOption} color="primary">
                                    <AddCircleOutlineOutlinedIcon />
                                </IconButton>

                            </InputAdornment>
                        }
                        label="Nueva version"
                    />
                    <FormHelperText>Por ejemplo: "Acompañamiento" , "Salsas extra", "Aderezos", "Bebida"</FormHelperText>
                </FormControl>

                <Helper
                    text='Escribe el nombre que va a tener la versión de tu producto y luego podrás elegir las opciones que tu cliente va a poder elegir'
                    style={{ marginBottom: '20px' }}
                />
            </Stack>

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />

            <EasySnackBar
                severity='success'
                key='2'
                message={successMessage}
                setMessage={setSuccessMessage}
            />
        </>
    )
}